import { render, staticRenderFns } from "./Debit.vue?vue&type=template&id=f065b124"
import script from "./Debit.vue?vue&type=script&lang=js"
export * from "./Debit.vue?vue&type=script&lang=js"
import style0 from "./Debit.vue?vue&type=style&index=0&id=f065b124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports